require("./bootstrap");
require("jquery-datetimepicker");
require("jquery-ui/ui/widgets/datepicker");
require("jquery-ui/ui/i18n/datepicker-ja");